module.exports = "import React from 'react';\nimport Checkbox from 'material-ui/Checkbox';\n\nconst StylesOverridingCssExample = () => (\n  <Checkbox\n    name=\"StylesOverridingCssExample\"\n    label=\"Checked the mail\"\n    className=\"styles-overriding-css-example\"\n  />\n);\n\nexport default StylesOverridingCssExample;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/customization/StylesOverridingCssExample.js
 ** module id = 1096
 ** module chunks = 0
 **/